/**
 * ReviewDashboardPresenter
 * --
 */
import React, { useRef, useState, useEffect } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Statistic,
} from 'components';
import { Button, DatePicker, Divider, Input, Table, Radio, Spin } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import {
  // XAxis,
  // YAxis,
  // BarChart,
  // Bar,
  // Legend,
  CartesianGrid,
  // ComposedChart,
  Tooltip,
  Cell,
  BarChart,
  Pie,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Legend,
  Bar,
  Rectangle,
} from 'recharts';
import { stringToMoneyFormat } from 'utils';

const data = [
  { name: 'Group A', value: 400 },
  { name: 'Group B', value: 300 },
  { name: 'Group C', value: 300 },
  { name: 'Group D', value: 200 },
];

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

/**----------------------------------------
 * [Component] 총관리자: 장바구니 분석 - 프레젠터
 * ----------------------------------------
 */
const ReviewDashboardPresenter = ({
  loading,
  chartData,
  statisticsType,
  setStatisticsType,
  handleGetCartList,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const chartRef = useRef(null);
  const [chartWidth, setChartWidth] = useState(0);

  /* ===== VARIABLE ===== */
  const formItem = [
    {
      label: '기간설정',
      form: [
        {
          input: (
            <>
              <Radio.Group
                size="large"
                defaultValue="month"
                buttonStyle="solid"
                value={statisticsType}
                onChange={(e) => setStatisticsType(e.target.value)}
                style={{ marginRight: 12 }}
                // disabled={
                //   searchFilter.startDate || searchFilter.endDate ? true : false
                // }
              >
                <Radio.Button value="today">오늘</Radio.Button>
                <Radio.Button value="week">1주일(7일)</Radio.Button>
                <Radio.Button value="month">1개월(30일)</Radio.Button>
                <Radio.Button value="3month">3개월(90일)</Radio.Button>
              </Radio.Group>
              {/* <>
                <DatePicker
                  size="large"
                  format={'YYYY-MM-DD'}
                  placeholder="시작일"
                  // style={{ ...styles.form.date }}
                  // onChange={(d, t) => handleChange('startDate', t)}
                />
                <p style={{ padding: '0px 2px' }}>~</p>
                <DatePicker
                  size="large"
                  format={'YYYY-MM-DD'}
                  placeholder="종료일"
                  // style={{ ...styles.form.date }}
                  // onChange={(d, t) => handleChange('endDate', t)}
                />
              </> */}
            </>
          ),
        },
      ],
    },
  ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  useEffect(() => {
    const call = (e) => {
      setChartWidth(chartRef.current.clientWidth);
    };
    if (chartRef.current) call();
    window.addEventListener('resize', call);
    return () => {
      window.removeEventListener('resize', call);
    };
  }, [chartRef]);

  /*  */
  const RADIAN = Math.PI / 180;
  /*  */
  const renderCustomLabel = (d) => {
    const { cx, cy, midAngle, innerRadius, outerRadius, percent, name } = d;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="black"
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
      >
        {`${name}: ${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };
  /* 상품별 데이터 */
  const productChart = chartData?.product
    ? Object.keys(chartData.product).map((item) => ({
        name: chartData.product[item].label,
        value: chartData.product[item].data.length,
        ...chartData.product[item],
      }))
    : [];
  /* 카테고리별 데이터 */
  const categoryChart = chartData?.category
    ? Object.keys(chartData.category).map((item) => ({
        name: chartData.category[item].label,
        value: chartData.category[item].data.length,
      }))
    : [];
  /* 브랜드별 데이터 */
  const shopChart = chartData?.shop
    ? Object.keys(chartData.shop).map((item) => ({
        name: chartData.shop[item].label,
        value: chartData.shop[item].data.length,
      }))
    : [];

  /* ===== RENDER ===== */
  return (
    <Spin spinning={loading}>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title size={4} style={{ marginBottom: 12 }}>
              장바구니 분석
            </Title>

            {/* 검색필터 */}
            <Content
              maxWidth={'100%'}
              padding={0}
              // backgroundColor={'none'}
              style={{ marginBottom: 5 }}
            >
              <Row>
                <Col x={19}>
                  <ExpandableContainer borderRadius={4} padding={20}>
                    {formItem.map((_item, _index) => (
                      <div
                        key={`form_${_index}`}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '10px 0px',
                        }}
                      >
                        <div
                          style={{ width: 120, fontSize: 13, fontWeight: 400 }}
                        >
                          <label>{_item.label}</label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          {_item.form.map((_subitem, _subkey) => (
                            <React.Fragment key={`input_${_subkey}`}>
                              {_subitem.input}
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                    ))}
                  </ExpandableContainer>
                </Col>
                {/* === === */}
                <Col
                  x={5}
                  style={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                  }}
                >
                  <Button
                    size="large"
                    type="primary"
                    onClick={() => handleGetCartList()}
                  >
                    <SearchOutlined /> 검색
                  </Button>
                  &nbsp;
                  <Button
                    size="large"
                    // onClick={handleResetFilter}
                  >
                    <ReloadOutlined /> 초기화
                  </Button>
                </Col>
              </Row>
            </Content>
            {/* 검색필터 끝 */}

            {/* 요약 */}
            <Content
              maxWidth={'100%'}
              padding={0}
              backgroundColor={'none'}
              style={{ marginBottom: 5 }}
            >
              <Row gutter={[5, 5]}>
                {[
                  {
                    title: '상품수',
                    value: chartData?.product
                      ? Object.keys(chartData?.product).length
                      : 0,
                    unit: '개',
                  },
                  {
                    title: '카테고리수',
                    value: chartData?.category
                      ? Object.keys(chartData?.category).length
                      : 0,
                    unit: '개',
                  },
                  {
                    title: '브랜드수',
                    value: chartData?.shop
                      ? Object.keys(chartData?.shop).length
                      : 0,
                    unit: '개',
                  },
                ].map((_item, _index) => (
                  <Col x={8} key={`${_item.label}-${_index}`}>
                    <Content width="100%" padding={'20px 0'}>
                      <Statistic
                        title={_item.title}
                        value={_item.value}
                        suffix={_item.unit}
                        direction={'row'}
                        style={{ justifyContent: 'center' }}
                      />
                    </Content>
                  </Col>
                ))}
              </Row>
            </Content>
            {/* 요약 끝 */}

            {/* ===== 차트: start ===== */}
            <Row gutter={[5, 5]}>
              {/* === 상품별: start === */}
              <Col x={24}>
                <Content
                  maxWidth={'100%'}
                  borderRadius={4}
                  padding={'14px 5px'}
                >
                  <Title
                    size={5}
                    align="center"
                    style={{ padding: '14px 20px' }}
                  >
                    장바구니에 담긴 상위 10개 상품
                  </Title>
                  <Divider style={{ margin: 0 }} />
                  <ResponsiveContainer width="100%" height={450}>
                    <BarChart
                      width={500}
                      height={300}
                      data={[
                        {
                          name: '2024.08',
                          Review: 4000,
                          ProductOrder: 2400,
                          amt: 2400,
                        },
                        {
                          name: '2024.09',
                          Review: 3000,
                          ProductOrder: 1398,
                          amt: 2210,
                        },
                        {
                          name: '2024.10',
                          Review: 2000,
                          ProductOrder: 9800,
                          amt: 2290,
                        },
                        {
                          name: '2024.11',
                          Review: 2780,
                          ProductOrder: 3908,
                          amt: 2000,
                        },
                        {
                          name: '2024.12',
                          Review: 1890,
                          ProductOrder: 4800,
                          amt: 2181,
                        },
                        {
                          name: '2025.01',
                          Review: 2390,
                          ProductOrder: 3800,
                          amt: 2500,
                        },
                        {
                          name: '2025.02',
                          Review: 3490,
                          ProductOrder: 4300,
                          amt: 2100,
                        },
                      ]}
                      margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                      }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Bar
                        dataKey="ProductOrder"
                        fill="#8884d8"
                        activeBar={<Rectangle fill="pink" stroke="blue" />}
                      />
                      <Bar
                        dataKey="Review"
                        fill="#82ca9d"
                        activeBar={<Rectangle fill="gold" stroke="purple" />}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </Content>
              </Col>
              {/* === 상품별: end === */}
            </Row>
            {/* ===== 차트: end ===== */}

            {/* ===== Raw 데이터: start ===== */}
            <Row gutter={[5, 5]}>
              <Col x={24}>
                <Content
                  maxWidth={'100%'}
                  padding={20}
                  // backgroundColor={'none'}
                  style={{ margin: '5px 0' }}
                >
                  <Title size={5} style={{ marginBottom: 10 }}>
                    상품별 순위
                  </Title>
                  <Table
                    bordered
                    size="small"
                    dataSource={
                      productChart
                        .sort((a, b) => a.value - b.value)
                        .reverse() ?? []
                    }
                    columns={[
                      {
                        title: '상품명',
                        dataIndex: 'name',
                      },
                      {
                        title: '업체명',
                        dataIndex: 'shop_information_name',
                        width: 350,
                        align: 'center',
                      },
                      {
                        title: '저장횟수',
                        dataIndex: 'value',
                        width: 170,
                        align: 'center',
                        render: (value) => `${stringToMoneyFormat(value)}개`,
                      },
                      {
                        title: '판매가격',
                        dataIndex: 'price',
                        width: 150,
                        align: 'center',
                        render: (value) => `${stringToMoneyFormat(value)}원`,
                      },
                    ]}
                  />
                </Content>
              </Col>
            </Row>
            {/* ===== Raw 데이터: end ===== */}
          </Col>
        </Row>
      </Content>
    </Spin>
  );
};

export default ReviewDashboardPresenter;
